import SwivuSettingsTagValueTabBase from "./SwivuSettingsTagValueTabBase.jsx";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";

const GRID_KEYS = {
  statusGrid: "resourceStatusGrid"
};

export default class SwivuSettingsResourceStatusTab extends SwivuSettingsTagValueTabBase {
  static get $name() {
    return "SwivuSettingsResourceStatusTab";
  }

  static get type() {
    return "swivusettingsresourcetab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.resourceStatusTab;
  }

  getStoreName() {
    return STORE_KEYS.resourceTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.status]: GRID_KEYS.statusGrid
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.statusGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  static get configurable() {
    return {
      title: "Resources",
      scrollable: true,
      ...SwivuSettingsTagValueTabBase.getDefaultLayoutSettings(),
      items: {
        [GRID_KEYS.statusGrid]: SwivuSettingsTagValueTabBase.getGridWidget({
          headerText: "Resource Status",
          defaultValue: "Enter Status"
        })
      }
    };
  }
}

SwivuSettingsResourceStatusTab.initClass();
